<template>
  <x-dialog
    width="50%"
    :dialogTitle="dialogTitle"
    :dialogState="createCollaboratorDialogIsOpen"
    @toggleModal="closeDialog"
    :actions="{
      show: true,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: saveCollabaorator,
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Save',
    }"
    :data-test-id="`${dataTestId}`"
  >
    <template slot="dialog_data">
      <v-card-text flat class="ml-2">
        <v-row
          align="center"
        >
          <v-col sm="3">
            <span class="formInputLabel">Email address</span>
          </v-col>
        </v-row>
          <v-autocomplete
            ref="selectCollab"
            multiple
            name="autocomp"
            clearable
            label="Select collaborators"
            solo
            flat
            :items="collabList"
            filled
            hide-selected
            height="52px"
            type
            append-icon="keyboard_arrow_down"
            background-color="#E5E5E5 !important"
            item-text="fullName"
            item-value="id"
            v-model="collabModel"
            v-on:keyup.enter="addItems(collabModel, selectedCollabList)"
            v-on:change="addItems(collabModel, selectedCollabList)"
            class="col-12"
            :data-test-id="`${dataTestId}__email-select-box`"
          >
            <template v-slot:item="data">
              <v-list-item-content :data-test-id="`${dataTestId}__email-list-item-${data.item.id}`">
                <v-list-item-title>{{ data.item.fullName }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  data.item.email[0]
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>

        <div
          class="list-container"
          v-if="selectedCollabObjectList.length > 0"
          :data-test-id="`${dataTestId}__collab-list`"
        >
          <tag
            v-for="(item, index) in selectedCollabObjectList"
            :key="item.id"
            :text="item.name"
            data-class="dynamicTagsdark"
            :showDelete="true"
            @click="
              deleteItem(item, selectedCollabObjectList)
              "
            :data-test-id="`${dataTestId}__collab-list-item-${index+1}`"
          ></tag>
        </div>
      </v-card-text>
    </template>
  </x-dialog>
</template>

<script>
var findIndex = require('lodash.findindex');
import ProjectService from '../../services/ProjectService';
import EventBus from '@/EventBus';

export default {
  data() {
    return {
      maxCollab: 5,
      dialogTitle: 'Add a collaborator',
      createCollaboratorDialogIsOpen: false,
      darkTheme: null,
      collabItem: null,
      collabName: '',
      collabModel: null,
      selectedCollabList: [],
      selectedCollabObjectList: [],
      allUsers:[],
      dataTestId:'add-new-collab-dialog'
    };
  },
  props: {
    dialogOpen: Boolean,
    allUserArr: Array,
    collaboratorsList: Array,
    allUserObj: Object,
  },
  created: function() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  mounted() {
    this.allUsers = JSON.parse(JSON.stringify(this.allUserArr));

    this.allUsers.forEach(user => {
      user['text'] = user.firstName;
      user['value'] = user.id;
      user['fullName'] = this.formatFullName(user);
    });
    let userId = localStorage.getItem('userId');
    const userIndex = this.allUsers.findIndex(user => user.id === userId);

    if (userIndex !== -1) {
      this.allUsers.splice(userIndex, 1);
    }
    this.collaboratorsList.forEach(collab => {
      const collaboratorIndex = this.allUsers.findIndex(
        user => user.id === collab.id
      );
      if (collaboratorIndex !== -1) {
        this.allUsers.splice(collaboratorIndex, 1);
      }
    });
    this.createCollaboratorDialogIsOpen = this.dialogOpen;
  },
  methods: {
    escapeKeyListener: function(evt) {
      if (
        evt.keyCode === this.escapeKeyCode &&
        this.createCollaboratorDialogIsOpen
      ) {
        this.closeDialog();
      }
    },
    async saveCollabaorator() {
      if (!this.selectedCollabObjectList.length) {
        this.snackbar('error', this.$message.SELECT_COLLAB);
        return;
      }
      let collabList = [];
      this.selectedCollabObjectList.forEach(selectedCollab => {
        collabList.push(selectedCollab.id);
      });

      try {
        await ProjectService.saveCollaborators(
          this.$route.params.projectId,
          collabList
        );
        EventBus.$emit('REFRESH_COLLABORATORS', true);
        this.snackbar('success', this.$message.COLLAB_ADDED);
        this.closeDialog();
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    addItems() {
      this.$refs.selectCollab.isMenuActive = false;
      if (this.selectedCollabObjectList.length === this.maxCollab) {
        this.collabModel = [];
        this.snackbar(
          'error',
          'Only ' + this.maxCollab + ' collabrators can be added at a time'
        );
        return;
      }
      this.collabModel.forEach(id => {
        let user = this.allUserObj[id];
        let newObj = {
          id: id,
          name: this.formatFullName(user)
        };
        this.selectedCollabObjectList.push(newObj);
      });
      this.collabModel = [];
    },
    deleteItem(item, arr) {
      let index = findIndex(arr, el => {
        return el === item;
      });
      if (index >= 0) {
        arr.splice(index, 1);
      }
      this.addItems();
    },
    closeDialog() {
      this.createCollaboratorDialogIsOpen = false;
      this.$emit('closeOverlay', true);
    }
  },
  computed: {
    collabList() {
      let list = this.allUsers;
      this.selectedCollabObjectList.forEach(item => {
        list = list.filter(vl => {
          return vl.id !== item.id;
        });
      });
      return list;
    }
  },
  beforeDestroy() {}
};
</script>
